<div class="invoice-viewer-container">
  <div class="invoice-viewer-toolbar">
    <div class="toolbar-left">
      <p-button
        icon="pi pi-search-minus"
        (onClick)="zoomOut()"
        size="small"
        [ariaLabel]="'invoiceViewer.zoomOut' | translate"
        styleClass="p-button-rounded p-button-secondary"
      />
      <span class="toolbar-label">{{ zoomPercent }}%</span>
      <p-button
        icon="pi pi-search-plus"
        (onClick)="zoomIn()"
        size="small"
        [ariaLabel]="'invoiceViewer.zoomIn' | translate"
        styleClass="p-button-rounded p-button-secondary"
      />
    </div>

    <div class="toolbar-center">
      <span class="toolbar-label">{{ 'invoiceViewer.page' | translate }}</span>
      <p-inputNumber
        [(ngModel)]="page"
        [min]="1"
        [max]="totalPages"
        [useGrouping]="false"
        [showButtons]="false"
        inputStyleClass="custom-page-input"
        (onBlur)="onPageBlur()"
        (onKeyDown.enter)="onPageBlur()"
      ></p-inputNumber>
      <span class="toolbar-label">/ {{ totalPages }}</span>
    </div>

    <div class="toolbar-right">
      <p-button
        icon="pi pi-download"
        (onClick)="downloadPdf()"
        size="small"
        [ariaLabel]="'invoiceViewer.download' | translate"
        styleClass="p-button-rounded p-button-secondary"
      />
      <p-button
        icon="pi pi-print"
        (onClick)="printPdf()"
        size="small"
        [ariaLabel]="'invoiceViewer.print' | translate"
        styleClass="p-button-rounded p-button-secondary"
      />
      <p-button
        icon="pi pi-replay"
        (onClick)="rotateLeft()"
        size="small"
        [ariaLabel]="'invoiceViewer.rotateLeft' | translate"
        styleClass="p-button-rounded p-button-secondary"
      />
      <p-button
        icon="pi pi-refresh"
        (onClick)="rotateRight()"
        size="small"
        [ariaLabel]="'invoiceViewer.rotateRight' | translate"
        styleClass="p-button-rounded p-button-secondary"
      />
    </div>
  </div>

  <div class="invoice-viewer-wrapper" #viewerWrapper>
    <pdf-viewer
      [src]="fileSrc()"
      [zoom]="zoom"
      [rotation]="rotation"
      [show-all]="true"
      [render-text]="true"
      [autoresize]="true"
      [original-size]="false"
      (after-load-complete)="onPdfLoadComplete($event)"
      (page-rendered)="onPageRendered()"
      class="pdf-viewer"
    ></pdf-viewer>
  </div>
</div>
